import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import passportPhotoExample from '@helpers/passport-photo-example'
import convertToBase64 from '@helpers/file-to-base64'
import islands from '@constants/islands'
import Swal from 'sweetalert2'
import { BUSINESS_FIELDS, fullName } from '@modules/form-wizard/utils'
import toastr from '@modules/toastr'
import { GCExemptionModify } from './gc-exemption-modify'
import Loader from '@shared/loader'
import Modal from 'react-responsive-modal'

const guidelinesURL = "https://api.pilot-qa.gov.bs/system/public_attachments/file_uploads/000/000/008/original/NER_Green_Choice_Exemption_Program_Specifications_Guidelines.pdf?1752671405"

const NERGuideLinesPDF = (
<div className= 'flex' style={{justifyContent: 'center'}}>
<div className='flex flex-row items-center' style={{flexWrap: 'wrap'}}>
  <a className='flex flex-row items-center mr-1' style={{fontSize: '18px'}} href={guidelinesURL} target="_blank" rel='noreferrer'>
    NER Green Choice Exemption Program Specifications Guidelines
  </a>
</div>
</div>
)

export default class GreenChoiceExemption extends React.Component {
  state = { record: null, loading: false, all_reviewers: [], exemption_list: [] }
  resource = '/green_choice_exemptions'
  form_key = 'green_choice_exemption'

  isHousehold = /household/.test(this.props.location.pathname)
  isCommercial = /commercial/.test(this.props.location.pathname)
  isNonProfit = /non-profit/.test(this.props.location.pathname)

  decideType = () => {
    if (this.isHousehold) {
      return 'household'
    } else if (this.isCommercial) {
      return 'commercial'
    } else {
      return 'non-profit'
    }
  }

  defaults = {
    exemption_type: this.decideType(),
    client_type: this.isHousehold ? 'individual' : 'business',
  }

  read_params = {
    admin: true,
    label: ' ',
    default: 'Default',
    values: {
      'Default': {
        exemption_type: this.defaults.exemption_type,
      },
    },
  }

  // Delete lines as needed
  // fee = 99
  // free = true
  // postpaid = true
  skip_location = true
  hide_buttons = false
  pay_on_approval = true
  business_only = this.isCommercial
  hide_buttons = {
    status: true,
    deny: true,
    fee: true,
  }

  // updateView = update => {
  //   const { history, location } = this.props
  //   const inview = location.state?.view

  //   inview &&
  //     history.replace(location.pathname, {
  //       ...location.state,
  //       view: { ...inview, ...update },
  //     })
  // }

  custom_actions = [
    // Officer Actions
    {
      text: 'Modify Exemptions',
      icon: 'wrench',
      roles: [['officer', 'senior_officer']],
      test: r =>
        ['pending', 'officer viewed', 'processing'].includes(r.application_decision),
      fn: record => this.setState({ record }),
    },
    {
      text: 'Review Application',
      icon: 'check',
      roles: ['officer'],
      test: r => ['senior officer viewed'].includes(r.application_decision),
      fn: async record => {
        const { isDismissed, value } = await Swal.fire({
          icon: 'question',
          title: 'Review Details',
          html: `
            What are your concerns regarding the applicant, 
            <strong>${fullName(record.user, 'initial')}</strong>?
          `,
          input: 'select',
          inputOptions: {
            'approved': "I recommend this applicant",
            'denied': "I do not recommend this applicant",            
          },
          showCancelButton: true,
        })

        if (isDismissed) return

        this.setState({ loading: true })
        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: value,
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            console.log(view)
            view.application_decision = 'officer viewed'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application review submitted successfully')
        } catch (err) {
          console.error(err)
          Swal.fire(
            'Oops...',
            'An error occurred while reviewing the application',
            'error'
          )
        } finally {
          this.setState({ loading: false })
        }
      }
    },

    // Senior Officer Actions
    {
      text: 'Assign Officer',
      icon: 'bullhorn',
      roles: ['senior_officer'],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: async record => {
        // Get the list of officers
        const officerList = {};
        const { data } = await $app.axios.get('/green_choice_exemptions/show_reviewers')
        const officerMap = data.records.map(x => {
          return { id: x.id, name: `${x.first_name} ${x.last_name}` }
        })
        this.setState({ all_reviewers: officerMap })
        this.state.all_reviewers.forEach(e => {
          officerList[`${e.id}`] = e.name;
        })

        let officerID = null
        const {isDismissed, value} = await Swal.fire({
          icon: 'question',
          title: 'Assign Officer for review',
          html: `
            Select which officer you would wish to assign to this application.
          `,
          input: 'select',
          inputOptions: officerList,
          showCancelButton: true,
          confirmButtonText: 'Send',
        })
  
        if (isDismissed) return

        officerID = value
        // console.log(officerID)
        this.setState({ loading: true })
        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'assign reviewer',
              reviewer_id: officerID,
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            console.log(view)
            view.application_decision = 'senior officer viewed'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application approved for review successfully')
        } catch (err) {
          console.error(err)
          Swal.fire(
            'Oops...',
            'An error occurred while approving the application for review',
            'error'
          )
        } finally {
          this.setState({ loading: false })
        }
      }
    },
    {
      text: 'Claim Application',
      icon: 'check',
      roles: [['senior_officer']],
      test: r => {
        if (['pending', 'processing'].includes(r.application_decision) && r.reviewer_id !== $app.current_user.id) {
          return true
        }

        return false
      },
      fn: async record => {
        const { isDismissed, value } = await Swal.fire({
          icon: 'question',
          title: 'Claim Application for Review',
          html: `
            Are you claiming this application for review, 
            <strong>${fullName(record.user, 'initial')}</strong>?
          `,
          input: 'select',
          inputOptions: {
            'claimed': "I claim this application for review",
            'no': "I do not wish to claim this application",            
          },
          showCancelButton: true,
        })

        if (isDismissed) return
        if (value === 'no') return

        this.setState({ loading: true })
        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: value,
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            console.log(view)
            view.application_decision = 'claimed'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application review submitted successfully')
        } catch (err) {
          console.error(err)
          Swal.fire(
            'Oops...',
            'An error occurred while reviewing the application',
            'error'
          )
        } finally {
          this.setState({ loading: false })
        }
      }
    },
    {
      text: 'Approve Certificate',
      icon: 'check',
      roles: ['senior_officer'],
      test: r => {
        if (['pending', 'processing'].includes(r.application_decision) && r.reviewer_id === $app.current_user.id) {
          return true
        }

        if (['officer viewed'].includes(r.application_decision)) {
          return true
        }

        return false
      },
      fn: async record => {
        const title = record.renewal ? 'Approve Certificate' : 'Approve For Payment'
        const text = record.renewal ? 
          `Are you sure you want to approve this application and generate their permit? ` : 
          `Are you sure you want to approve this application and allow
          the applicant to pay? `
        const { isDismissed } = await Swal.fire({
          icon: 'question',
          title: title,
          html: `<div>
          
            <div style="text-align:left; border:1px solid #ddd; border-radius:6px; padding:10px; margin-top:10px;">
              <p style="margin:0 0 4px;"><strong>Applicant</strong> (${fullName(record.user, 'initial')})</p>
              <p style="margin:0 0 4px;"><strong>Application Type:</strong> ${record.exemption_type}</p>
              <p style="margin:0;"><strong>Fridge Quantity:</strong> ${record.fridge_quantity || 0}</p>
              <p style="margin:0;"><strong>Freezer Quantity:</strong> ${record.freezer_quantity || 0}</p>
              <p style="margin:0;"><strong>Walk-in Fridge Quantity:</strong> ${record.walk_in_fridge_quantity || 0}</p>
              <p style="margin:0;"><strong>Walk-in Freezer Quantity:</strong> ${record.walk_in_freezer_quantity || 0}</p>
              <p style="margin:0;"><strong>Water Heater Quantity:</strong> ${record.water_heater_quantity || 0}</p>
              <p style="margin:0;"><strong>Air Conditioner Quantity:</strong> ${record.air_conditioner_quantity || 0}</p>
            </div>
            <p>The quantities above are the values that will appear on the permit once generated. 
            Please ensure that all information is correct before approving the application.</p>
            <p>${text}</p>
            </div>`,
          confirmButtonText: 'Approve',
          showCancelButton: true,
        })

        if (isDismissed) return

        this.setState({ loading: true })
        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'approved',
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            console.log(view)
            view.application_decision = 'awaiting payment'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application approved for payment successfully')
        } catch (err) {
          console.error(err)
          Swal.fire(
            'Oops...',
            'An error occurred while approving the application',
            'error'
          )
        } finally {
          this.setState({ loading: false })
        }
      }
    },
    {
      text: 'Deny',
      icon: 'ban',
      roles: ['senior_officer'],
      test: r => ['pending', 'processing', 'officer viewed'].includes(r.application_decision),
      fn: async record => {
        const { isDismissed } = await Swal.fire({
          icon: 'error',
          title: 'Confirm Denial',
          text: 'Are you sure you want to deny this application?',
          confirmButtonText: 'Deny',
          showCancelButton: true,
        })

        if (isDismissed) return

        this.setState({ loading: true })
        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'denied',
            },
          })
          // console.log(this)
          if (location?.state?.view) {
            const view = { ...location.state.view }
            // console.log('location', location, 'location state', location.state, 'location state view', view)
            view.application_decision = 'denied'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application denied successfully')
        } catch (err) {
          console.error(err)
          Swal.fire(
            'Oops...',
            'An error occurred while denying the application',
            'error'
          )
        } finally {
          this.setState({ loading: false })
        }
      }
    },
    {
      text: 'Override Status',
      icon: 'hammer',
      roles: ['senior_officer'],
      test: r => ['approved', 'denied', 'awaiting payment'].includes(r.application_decision),
      fn: async record => {
        const { isDismissed } = await Swal.fire({
          icon: 'error',
          title: 'Confirm Override',
          html: `Are you sure you want to override the status of this application? </br></br> This action will change the status of the 
           application back to processing and will allow the officers to review the application again.`,
          confirmButtonText: 'Override',
          showCancelButton: true,
        })

        if (isDismissed) return

        this.setState({ loading: true })
        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'override',
            },
          })
          // console.log(this)
          if (location?.state?.view) {
            const view = { ...location.state.view }
            // console.log('location', location, 'location state', location.state, 'location state view', view)
            view.application_decision = 'override'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application overridden successfully')
        } catch (err) {
          console.error(err)
          Swal.fire(
            'Oops...',
            'An error occurred while overriding the application',
            'error'
          )
        } finally {
          this.setState({ loading: false })
        }
      }
    },
  ]

  // Show popup so user is prompted to read the specification guidelines
  // If they have not, show an error message and go back
  restrictApplication = () => {
    Swal.fire({
      title: "Have you read the Program Specification Guidelines?",
      html: `<div><a href="${guidelinesURL}" target="_blank">Applicants must read the NER Green Choice Exemption Program Specifications Guidelines before proceeding to 
        the application form and ensure their appliance(s) meet the applicable specifications.</a>
        </br></br>Click the link below to view specifications guidelines.
        </br></br><a href="${guidelinesURL}" target="_blank">NER Specifications Guidelines</a></div>`,
      icon: "warning",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCancelButton: true,
      confirmButtonColor: "#2aa74b",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, I have read the specification guidelines!",
      cancelButtonText: "No, I have not read the specification guidelines",
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        const { history } = this.props

        Swal.fire({
          title: "You must read Specification Guidelines!",
          html: `<div><a href="${guidelinesURL}" target="_blank">Applicants must read the NER Green Choice Exemption Program Specifications Guidelines before proceeding to 
            the application form and ensure their appliance(s) meet the applicable specifications.</a>
            </br></br>Click the link below to view specifications guidelines.
            </br></br><a href="${guidelinesURL}" target="_blank">NER Specifications Guidelines</a></div>`,
          icon: "error"
        });
        console.log(history)
        window.open(guidelinesURL, '_blank')
        
        return history.push(history.location.pathname)
      }

      Swal.fire({
        title: "Associated Fees",
        html: `The Green Choice Exemption annual permit fee structure is as follows:</br></br>
            <div><h4>Households</h4>
            <b>Annual permit fee: $100.00</b>
            (For import of four eligible air conditioners, two eligible refrigerators, two eligible freezers, and two eligible water heaters)</div></br>
            <div><h4>Commercial Entities</h4>
            <b>Annual permit fee: $300.00</b>
            (For import of an unlimited number of eligible air conditioners, refrigerators, freezers and water heaters)</div></br>
            <div><h4>Non-profit Organization</h4>
            <b>Annual permit fee: $100.00</b>
            (For import of four eligible air conditioners, two eligible refrigerators, two freezers, and two water heaters)</div></br>
            <div><h4>Social Support Non-Profit Organizations</h4>
            (e.g. churches, children's homes, retirement homes, feeding programmes)
            </br><b>One-time permit fee: $75.00</b>
            (For import of four eligible air conditioners, two eligible refrigerators, two eligible freezers, and two eligible water heaters each year)</div>`,
        icon: "info",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
        confirmButtonColor: "#2aa3a7ff",
        // cancelButtonColor: "#d33",
        confirmButtonText: "Understood",
        // cancelButtonText: "No",
    })
    });
  }

  async componentDidMount () {
    if ($app.roles.includes('pilot')) {
      this.restrictApplication()
    } else {
      try {
        const { data } = await $app.axios.get('/profiles/')
        this.setState({ profile: data })
      } catch (error) {
        console.error(error)
      }
    }
  }

  before_apply = () => this.restrictApplication()

  validate = async values => {
    const update = {}

    let index = 0

    if(values.itemized_receipts_attachments[0]) {
      update.itemized_receipts_attachments = []

      for (let row of values.itemized_receipts_attachments) {
        const {
          receipt_upload,
          ...item
        } = row
        index ++

        if (receipt_upload) {
          item.title = `${item.item_type} Receipt - ${index}`
          item.desc = `Receipt for ${item.item_type} - ${index}`
          item.file_upload = await convertToBase64(receipt_upload)
          update.itemized_receipts_attachments.push(item)
        }
      }
    }

    if (values.exemption_type === 'non-profit') {
      values.social_non_profit ? update.exemption_type = 'social non-profit' : update.exemption_type = 'non-profit'
    }

    return update
  }

  foremost = null

  commercialFieldsCheck = form => {
    if (form.exemption_type == 'commercial') return BUSINESS_FIELDS(form)
    return []
  }

  companyDetails = (form) => {
    if (['non-profit', 'social non-profit'].includes(form.exemption_type)) {
      return [
        '::Company Details',
        {
          name: 'company_name',
          label: 'Company Name',
          required: true,
          hide: !this.isNonProfit,
        },
        {
          name: 'company_address',
          label: 'Company Address',
          type: 'address',
          required: false,
          hide: !this.isNonProfit,
        },
      ]
    }

    return []
  }

  applianceQuantity = (form) => {
    return form.exemption_type == 'commercial' ? [
      {
        name: 'fridge_quantity',
        label:
          'Quantity of refrigerators you are planning to import under this application',
        type: 'integer',
      },
      {
        name: 'freezer_quantity',
        label:
          'Quantity of freezers you are planning to import under this application',
        type: 'integer',
      },
      {
        name: 'walk_in_fridge_quantity',
        label:
          'Quantity of walk-in refrigerators you are planning to import under this application',
        type: 'integer',
      },
      {
        name: 'walk_in_freezer_quantity',
        label:
          'Quantity of walk-in freezers you are planning to import under this application',
        type: 'integer',
      },
      {
        name: 'water_heater_quantity',
        label:
          'Quantity of water heaters you are planning to import under this application',
        type: 'integer',
      },
      {
        name: 'air_conditioner_quantity',
        label:
          'Quantity of air conditioners you are planning to import under this application',
        type: 'integer',
      },
    ] :
    [
      {
        name: 'fridge_quantity',
        label:
          'Quantity of refrigerators you are planning to import under this application',
        options: ['0', '1', '2'],
      },
      {
        name: 'freezer_quantity',
        label:
          'Quantity of freezers you are planning to import under this application',
        options: ['0', '1', '2'],
      },
      {
        name: 'walk_in_fridge_quantity',
        label:
          'Quantity of walk-in refrigerators you are planning to import under this application',
        options: ['0', '1', '2'],
        hide: form.exemption_type == 'household',
      },
      {
        name: 'walk_in_freezer_quantity',
        label:
          'Quantity of walk-in freezers you are planning to import under this application',
        options: ['0', '1', '2'],
        hide: form.exemption_type == 'household',
      },
      {
        name: 'water_heater_quantity',
        label:
          'Quantity of water heaters you are planning to import under this application',
        options: ['0', '1', '2'],
      },
      {
        name: 'air_conditioner_quantity',
        label:
          'Quantity of air conditioners you are planning to import under this application',
        options: ['0', '1', '2', '3', '4'],
      },
    ]
  }

  // appliancesSelected = (form) => {
  //   if (form?.seek_incentive_list?.length <= 0)
  //     return ({
  //     name: 'no_appliance_selected',
  //     heading: (
  //       <p>Please choose appliances from the list above</p>
  //     ),
  //     view: false,
  //   })
  // }

  columns = props => [
    {
      name: 'Officer Assigned',
      selector: row => row.reviewer ? `
        ${row.reviewer.first_name[0].toUpperCase() + row.reviewer.first_name.substring(1)} ${row.reviewer.last_name[0].toUpperCase() + row.reviewer.last_name.substring(1)}
      ` : 'N/A',
      sortable: true,
      // searchable: r => r.reviewer,
    },

    {
      name: 'Recommendation',
      selector: row => {
        const notes = row.notes.filter(n => n.text.includes('issue'))
        // console.log(notes)
        if (notes.length > 0) {
          const bracketIndex = notes[notes.length - 1].text.indexOf('(')
          // console.log(bracketIndex)

          return notes[notes.length - 1].text.substring(bracketIndex)
        }
        return 'N/A'
      },
      sortable: true,
      // searchable: r => r.reviewer,
    },
  ]

  fields = form => [
    {
      name: 'renewal',
      hide: true,
      save: true,
      view: true,
    },
    {
      name: 'exemption_type',
      hide: true,
      save: true,
      view: true,
    },
    {
      name: 'client_type',
      label: 'Application Type',
      save: true,
      hide: true,
    },
    {
      name: 'ner_guidelines',
      heading: (
        <div className='mb-4'>
          <center>
            <h4>NER Specification Guidelines</h4>
            {NERGuideLinesPDF}
          </center>
        </div>
      ),
      view: false
    },

    ...this.commercialFieldsCheck(form),

    {
      name: 'social_non_profit',
      label: 'Are you a social non-profit?',
      type: 'select:bool',
      hint: `Eg. children homes, 
        retirement homes, feeding programmes, and Churches`,
      hide: !this.isNonProfit,
      view: false,
    },

    ...this.companyDetails(form),

    '::Address and Residence Information',
    {
      name: 'street_address',
      label: 'Street address',
      // type: 'integer',
    },
    {
      name: 'building_number',
      type: 'integer',
    },
    {
      name: 'island',
      options: islands,
    },
    {
      name: 'settlement',
      required: false,
      hint: 'Family island only',
    },
    {
      name: 'post_code',
      label: 'Postal Code',
      required: false,
    },

    '::Application Information',
    {
      name: 'household_energy_renewable',
      label: `Does your ${this.isHousehold? 'household' : 'business'} have renewable energy?`,
      type: 'select:bool',
      hint: 'Example: Solar panels',
    },
    {
      name: 'household_total_support',
      label: `Is your ${this.isHousehold? 'household' : 'business'} 100% supported by renewable energy?`,
      type: 'select:bool',
      hide: !form.household_energy_renewable,
    },
    {
      name: 'household_total_support_desc',
      label:
        `How long has your ${this.isHousehold? 'household' : 'business'} operated as net-zero or carbon neutral?`,
      hide: !form.household_total_support,
    },

    {
      name: 'appliance_use',
      label: 'Will your company be using the new appliances for retail or for improving energy efficiency?',
      multi: true,
      options: [
        'retail',
        'improving energy efficiency',
      ],
      hide: !this.isCommercial,

    },
    {
      name: 'appliance_use_desc',
      label: 'Please provide information on how participation in this incentive will benefit your business',
      hide: this.isHousehold,
    },
    {
      name: 'seek_incentive_list',
      label:
        'Which energy efficient appliances are you seeking this incentive for?',
      hint: 'select all that apply',
      multi: true,
      options: form.exemption_type == 'household' ? [
        'refrigerator',
        'air conditioner',
        'freezer',
        'water heater',
      ] : 
      [
        'refrigerator',
        'air conditioner',
        'freezer',
        'walk-in freezer',
        'walk-in refrigerator',
        'water heater'
      ],
    },
    
    ...this.applianceQuantity(form),

    {
      name: 'reason_for_purchase',
      label: 'What is your reason for purchasing energy efficient appliances?',
      hint: 'Example: in need of a new refrigerator, cost savings, etc.',
      type: 'textarea',
    },

    '::Appliance Type, Make and Model Information',

    {
      name: 'no_appliance_selected',
      heading: (
        <p>Please choose appliances from the list above</p>
      ),
      view: false,
    },

    {
      name: 'ac_model',
      label: 'Make, model and efficiency metric of each air conditioner',
      fields: [
        'Make', 'Model',
        {
          name: 'Efficiency Metric',
          label: 'Efficiency Metric',
          options: [
            {
              value: 'SEER',
              label: 'SEER',
            },
            {
              value: 'SEER2',
              label: 'SEER2',
            },
            {
              value: 'CEER',
              label: 'CEER',
            },
          ],
          hint: 'Seasonal Energy Efficiency Ratio (SEER), Seasonal Energy Efficiency Ratio 2 (SEER2) or Combined Energy Efficiency Ratio (CEER)',
        },
        {
          name: 'quantity',
          type: 'integer',
        },
        {
          name: 'store_purchased',
          label: 'Store Purchased',
          hide: form.exemption_type == 'commercial',
        },
      ],
      hint: 'Example: Mini split A/C, MRCOOL, Model # DIY-12-HP-WM-115D25-O-CMB, 23.5 SEER2',
      hide: !form?.seek_incentive_list?.includes('air conditioner'),
    },
    {
      name: 'fridge_model',
      label: 'Make, model and KWh/year of each refrigerator',
      fields: ['Make', 'Model',
        { 
          name: 'kwh_per_year',
          label: 'kWh/year',
          type: 'integer',
        },
        {
          name: 'quantity',
          type: 'integer',
        },
        {
          name: 'store_purchased',
          label: 'Store Purchased',
          hide: form.exemption_type == 'commercial',
        }
      ],
      hint: 'Example: Side by side refrigerator, LG, Model #LRSOC2306, 645KWh / year',
      hide: !form.seek_incentive_list?.includes('refrigerator'),
    },
    {
      name: 'freezer_model',
      label: 'Make, model and KWh/year of each freezer',
      fields: ['Make', 'Model',
        { 
          name: 'kwh_per_year',
          label: 'kWh/year',
          type: 'integer',
        },
        {
          name: 'quantity',
          type: 'integer',
        },
        {
          name: 'store_purchased',
          label: 'Store Purchased',
          hide: form.exemption_type == 'commercial',
        },
      ],
      hint: 'eg. Chest Freezer, Frigidaire, Model # FFCL1542AW, 296KWh/year',
      hide: !form.seek_incentive_list?.includes('freezer'),
    },
    {
      name: 'walk_in_freezers_model',
      label: 'Type, make, model and BTU/hour of each walk-in freezer',
      fields: [
        'Make', 'Model',
        {
          name: 'temperature',
          options: [
            {
              value: 'low temperature',
              label: "Low Temperature (-19 °C to -86 °C)",
            },
            {
              value: 'medium temperature',
              label: "Medium Temperature (-4 °C to -18 °C)",
            },
          ],
          hint: 'Temperature in degrees Celsius',
        },
        { 
          name: 'btu_per_hour',
          label: 'BTU/hour',
          type: 'integer',
        },
        {
          name: 'quantity',
          type: 'integer',
        },
        {
          name: 'store_purchased',
          label: 'Store Purchased',
          hide: form.exemption_type == 'commercial',
        },
      ],
      hint: 'Example: Chest Freezer, Frigidaire, Model # FFCL1542AW, 296KWh/year',
      hide: !form.seek_incentive_list?.includes('walk-in freezer'),
    },
    {
      name: 'walk_in_fridges_model',
      label: 'make, model, BTU/hour of each walk-in refrigerator',
      fields: [
        'Make', 'Model',
        {
          name: 'temperature',
          options: [
            {
              value: 'low temperature',
              label: "Low Temperature (-19 °C to -86 °C)",
            },
            {
              value: 'medium temperature',
              label: "Medium Temperature (-4 °C to -18 °C)",
            },
          ],
          hint: 'Temperature in degrees Celsius',
        },
        { 
          name: 'btu_per_hour',
          label: 'BTU/hour',
          type: 'integer',
        },
        {
          name: 'quantity',
          type: 'integer',
        },
        {
          name: 'store_purchased',
          label: 'Store Purchased',
          hide: form.exemption_type == 'commercial',
        },
      ],
      hint: 'Example: Chest Refrigerator, Frigidaire, Model # FFCL1542AW, 296KWh/year',
      hide: !form.seek_incentive_list?.includes('walk-in refrigerator'),
    },
    {
      name: 'water_heater_model',
      label:
        'Make, model and Uniform Energy Factor (UEF) of each water heater',
      fields: ['Make', 'Model',
        { 
          name: 'uef',
          label: 'Uniform Energy Factor (UEF)',
          type: 'number',
        },
        {
          name: 'quantity',
          type: 'integer',
        },
        {
          name: 'store_purchased',
          label: 'Store Purchased',
          hide: form.exemption_type == 'commercial',
        },
      ],
      hint: 'Example: Electric heat pump, Rheem, Model # XE65T10H45U1, 4.05 UEF',
      hide: !form.seek_incentive_list?.includes('water heater'),
    },

    '::SPACER',
    // {
    //   name: 'where_purchased',
    //   label: 'Where did you purchase these appliances from?',
    //   hint: 'Name of store',
    // },

    '::Itemized Receipts',

    {
      name: 'itemized_receipts_attachments',
      label: 'Itemized Receipts',
      fields: [
        {
          name: 'item_type',
          label: 'Appliance type',
          hint: 'eg. Refrigerator #XE65T10H45, Air Conditioner, etc.',
        },
        {
          name: 'receipt_upload',
          label: 'Receipt Upload',
          type: 'file:all',
          required: true,
        },
      ],
    },

    '::Required Documents',
    // {
    //   name: 'nib_upload',
    //   label: 'National Insurance Card',
    //   key: 'image.1',
    //   type: 'file:all',
    //   hide: !this.isHousehold,
    // },
    // {
    //   name: 'business_license_upload',
    //   label: 'Business License',
    //   key: 'image.2',
    //   type: 'file:all',
    //   hide: !this.isCommercial,
    // },
    {
      name: 'non_profit_cert_of_registration_upload',
      label: 'Non-profit Certificate of Registration',
      key: 'image.3',
      type: 'file:all',
      hide: !this.isNonProfit,
    },
    {
      name: 'tax_compliance_upload',
      label: 'Tax Compliance Certificate',
      key: 'image.4',
      type: 'file:all',
      hide: this.isHousehold,
      required: this.isCommercial ? true : false,
    },
    {
      name: 'personal_id_upload',
      label:
        'Personal ID (eg. Passport or Driver’s License)',
      key: 'image.5',
      type: 'file:all',
      hint: passportPhotoExample,
      hide: !this.isHousehold,
    },
    {
      name: 'utility_bill_upload',
      label: 'Copy of utility bill with name of applicant',
      key: 'image.6',
      type: 'file:all',
      hide: !this.isHousehold,
    },

    // DECLARATION
    {
      name: 'meet_guidelines',
      label: `Do your imports meet the NER's "Green Choice Exemption Program Specification Guidelines?"`,
      hint: '(Refrigerators, freezers, air conditioners or water heaters only)',
      type: 'checkbox',
    },
  ]


  hidden_fields = () => [
    {
      name: 'pdf_upload',
      key: 'image.0',
      type: 'file:pdf',
      label: 'Green Choice Exemption Permit',
    },
  ]

  closeModal = ev => {
    ev && ev.preventDefault()
    this.setState({ record: null })
  }

  // stringifyJSON = json => json.map(j => JSON.stringify(j))

  saveExemptionSubmit = async approvedState => {
    this.setState({ loading: true })
    const { resource, form_key, props } = this
    const { history, location } = props
    const { axios } = $app
    const { record } = this.state

    // console.log({
    //     [form_key]: {
    //       form_num: record.form_num,
    //       ...approvedState,
    //     }})

    // return

    try {
      await axios.put(resource + '/update_exemptions', {
        [form_key]: {
          form_num: record.form_num,
          ...approvedState,
        },
      })

      if (location?.state?.view) {
        const view = { ...location.state.view }
        // const fields = [...view.fields].map(f => {
        //   return tables.includes(f.name)
        //     ? {
        //         ...f,
        //         value: approvedState[f.name],
        //       }
        //     : f
        // })

        // view.fields = fields

        history.replace(location.pathname, {
          ...location.state,
          view,
        })
      }

      Swal.fire(
        'Submitted!',
        'Exemptions sucessfully updated.',
        'success'
      ).then(() => window.location.reload())
    } catch (error) {
      console.error(error)
      Swal.fire(
        'Oops..',
        'Something went wrong with trying to modify the exemptions',
        'error'
      )
      return
    }

    this.setState({ loading: false, record: null })
  }

  render () {
    const {
      state,
      props,
      closeModal,
      fields,
      resource,
      form_key,
      update,
      saveExemptionSubmit,
    } = this
    const { record, loading } = state

    const fprops = {
      update,
      resource,
      closeModal,
      form_key,
      location: props.location,
      history: props.history,
      submit: saveExemptionSubmit,
    }

    if (record) {
      Object.assign(fprops, {
        record,
        fields: fields(record),
        tableName: `${record.user.first_name} ${record.user.no_middle_name || ''} ${record.user.last_name}`,
      })
    }

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Wizard {...SERVICE_PROPS(this)} />
        <Modal
          open={!!record}
          onClose={closeModal}
          center
          styles={{ modal: { maxWidth: '1920px', width: '90%', marginTop: '42px', position: 'relative' } }}
        >
          {fprops?.record && <GCExemptionModify record={record} fields={fprops['fields']} submit={fprops['submit']} closeModal={fprops['closeModal']} tableName={fprops['tableName']} />}
        </Modal>
      </React.Fragment>
    )
  }
}
